// ============================================================================
// view.pigsHome — the pig dashboard, read locally
// ============================================================================
// /pig rendered from FIVE inputs and owned none of them. Four were app_store
// blobs published by App's boot fan-out and reached through usePig() —
// ppp-breeding-v1, ppp-farrowing-v1, ppp-feeders-v1, ppp-breeders-v1 — and the
// fifth was the full pig_dailys history off useDailysRecent(). `pig.home.core`
// owns all five, which is what lets `pigsHome` retire from the frozen app_store
// and pig_dailys consumer lists in
// tests/fixtures/former-eager-dependencies.json.
//
// WHY THIS ONE IS PERMANENT WHERE ITS PIG SIBLINGS ARE NOT.
//
// Because it writes nothing. /pig/breeding, /pig/farrowing and /pig/sows each
// keep an App-owned `persist*` prop that owns a real app_store write AND the
// PigContext mirror the other pig surfaces still read — the same shape that
// keeps view.layers partial. This surface has no props at all, calls no setter,
// and performs no mutation. useUI().setView is navigation, not data, so there
// is genuinely nothing left to declare and `residualLegacy: []` is a checked
// claim rather than an omission.
//
// A FIFTH VALUE WAS DROPPED RATHER THAN MOVED. `useBatches().batches` was
// destructured here and never read. It is one of the app_store fields the
// former-eager derivation scores, so the retirement above would have been false
// while the hand-off stood — but localizing it would have been inventing a
// dependency, not relocating one. It is deleted, and pig.home.core does not
// read ppp-v4.
//
// THE FOUR BLOBS THROW AND THE DAILY HISTORY DOES NOT, and that split is App's
// boot reproduced rather than chosen here: the boot escalates a failed app_store
// read ("Failed to load app_store.") and degrades a failed
// `loadAllPigDailys(...)` to an empty history. See the resource's own comment.
// ============================================================================

import type {MigratedSurfaceDeclaration} from '../surfaceDataManifest';

const declaration: MigratedSurfaceDeclaration = Object.freeze({
  surface: 'view.pigsHome',
  obligations: Object.freeze([Object.freeze({id: 'pig.home.core', owner: 'permanent'})]),
  residualLegacy: Object.freeze([] as const),
});

export default declaration;
